import React from "react";

const ProductGrid = ({ children }) => {
  return (
    <div className="container mx-auto grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 pt-6 gap-8  mb-12">
      {children}
    </div>
  );
};

export default ProductGrid;
